import { render, staticRenderFns } from "./MFormAccountFullDialog.vue?vue&type=template&id=38b50ea9&scoped=true"
import script from "./MFormAccountFullDialog.vue?vue&type=script&lang=js"
export * from "./MFormAccountFullDialog.vue?vue&type=script&lang=js"
import style0 from "./MFormAccountFullDialog.vue?vue&type=style&index=0&id=38b50ea9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b50ea9",
  null
  
)

export default component.exports